import { takeLatest } from 'redux-saga/effects'
import { DELETE_USER_SAGA } from 'src/store/types/adminData'
import deleteUser from './deleteUser'

export function* deleteUserSaga() {
  yield takeLatest(DELETE_USER_SAGA, deleteUser)
}
